import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import moment from 'moment';

// components
import { CDateRangePicker, CButton } from '@coreui/react-pro'
import Select from 'react-select';
import AppCard from '../../components/AppCard'
import AppTable from 'src/components/AppTable'
import AppModalConfirmation from 'src/components/modal/AppModalConfirmation'

// styling
import { styleButtonVars2 } from '../../components/custom-styles/buttonStyles'

// helpers
import Axios from '../../helpers/axios'
import { columnClaimHistoryList } from '../../components/table-column/TableColumnList'
import { formUrlQuery } from '../../helpers/format-queries'

const ClaimHistoryList = () => {
  const dispatch = useDispatch()
  const params = useParams()
  const { status } = params

  const [claimHistoryList, setClaimHistoryList] = useState([]);
  const [claimHistoryListCount, setClaimHistoryListCount] = useState(0);
  const [claimHistoryListPerPage, setClaimHistoryListPerPage] = useState(10);
  const [activeClaimHistoryListPage, setActiveClaimHistoryListPage] = useState(1);
  const [searchClaimHistoryListFilter, setSearchClaimHistoryListFilter] = useState("");
  const [columnClaimHistoryListSorter, setColumnClaimHistoryListSorter] = useState({ column: "createdAt", state: "desc" });

  const [showModalExportFile, setShowModalExportFile] = useState({ show: false })

  const [filterStartDate, setFilterStartDate] = useState(null)
  const [filterEndDate, setFilterEndDate] = useState(null)

  const [columnFilter, setColumnFilter] = useState({})
  const [updateColumnList, setUpdateColumnList] = useState(columnClaimHistoryList)
  const claimStatusOptions = [
    { value: 'pending', label: 'Pending' },
    { value: 'processing', label: 'Processing' },
    { value: 'success', label: 'Success' },
    { value: 'refunded', label: 'Refunded' }
  ];
  const clientCodeOptions = [
    { value: true, label: 'Game Pass' },
    { value: false, label: 'MLWDP' }
  ];

  useEffect(() => {
    let queries = {
      search: searchClaimHistoryListFilter,
      limit: claimHistoryListPerPage,
      offset: claimHistoryListPerPage * activeClaimHistoryListPage - claimHistoryListPerPage,
      sort:
        (columnClaimHistoryListSorter &&
          `${columnClaimHistoryListSorter.column}-${columnClaimHistoryListSorter.state}`) ||
        "",
    };
    if (columnFilter) {
      Object.keys(columnFilter).forEach((key) => {
        if (columnFilter[key]) {
          queries[key] = columnFilter[key].value
        } else {
          queries[key] = ''
        }
      })
    }
    if (status == 'invalid') {
      queries['claim_status'] = 'failed'
    }
    queries = formUrlQuery(queries);
    fetchAllClaimHistories(queries);
  }, [
    searchClaimHistoryListFilter,
    claimHistoryListPerPage,
    activeClaimHistoryListPage,
    columnClaimHistoryListSorter,
    columnFilter,
    status
  ]);

  useEffect(() => {
    let columnList = columnClaimHistoryList?.map((list) => {
      let data = list

      if (data.key == 'client_code') {
        data.filter = (_, onChange) => {
          return (
            <Select
              options={clientCodeOptions}
              value={columnFilter.is_game_pass}
              onChange={(e) => {
                const selectedValue = e;
                onChange(selectedValue); // Ini yang penting! Meneruskan nilai ke SmartTable
                setColumnFilter((prevState) => ({
                  ...prevState,
                  is_game_pass: selectedValue
                }));
              }}
              isClearable
            />
          )
        }
      }

      if (status === 'valid' && data.key == 'claim_status') {
        data.filter = (_, onChange) => {
          return (
            <Select
              options={claimStatusOptions}
              value={columnFilter.claim_status}
              onChange={(e) => {
                const selectedValue = e;
                onChange(selectedValue); // Ini yang penting! Meneruskan nilai ke SmartTable
                setColumnFilter((prevState) => ({
                  ...prevState,
                  claim_status: selectedValue
                }));
              }}
              isClearable
            />
          )
        }
      } else if (status === 'invalid' && data.key == 'claim_status') {
        data.filter = false
      }

      if (data.key == 'createdAt') {
        data.filter = () => {
          return (
            <CDateRangePicker
              footer
              cleaner
              size="sm"
              startDate={filterStartDate}
              endDate={filterEndDate}
              onStartDateChange={(date) => {
                if (date) {
                  const itemDate = moment(date).format('YYYY-MM-DD')
                  setFilterStartDate(itemDate)

                  setColumnFilter((prevState) => ({
                    ...prevState,
                    created_start_date: {
                      value: itemDate,
                    }
                  }));

                  if (filterEndDate) {
                    setActiveClaimHistoryListPage(1)
                  }
                } else {
                  setColumnFilter((prevState) => ({
                    ...prevState,
                    created_start_date: null
                  }));
                  setFilterStartDate(null)
                }
              }}
              onEndDateChange={(date) => {
                if (date) {
                  const itemDate = moment(date).format('YYYY-MM-DD')
                  setFilterEndDate(itemDate)

                  setColumnFilter((prevState) => ({
                    ...prevState,
                    created_end_date: {
                      value: itemDate,
                    }
                  }));

                  if (filterStartDate) {
                    setActiveClaimHistoryListPage(1)
                  }
                } else {
                  setColumnFilter((prevState) => ({
                    ...prevState,
                    created_end_date: null
                  }));
                  setFilterEndDate(null)
                }
              }}
            />
          )
        }
      }

      return data
    })

    if (status === 'valid') {
      columnList = columnList.filter((item) => item.key !== 'failed_reason');
    }

    setUpdateColumnList(columnList)
  }, [columnFilter, status])

  const handleSearchItems = (search) => {
    setActiveClaimHistoryListPage(1)
    setSearchClaimHistoryListFilter(search);
  }

  const fetchAllClaimHistories = (queries) => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "get",
      url: `/api/gamepass/v1/history/list?${queries}`
    })
      .then(({ data }) => {
        const tempClaimHistoryList = data?.value?.map((d) => ({
          ...d,
          client_code: d?.client_voucher?.client_code || '-',
          mlbb_account_id: d?.mlbb_account_id || '-',
          mlbb_zone: d?.mlbb_zone || '-',
          claim_status: d?.claim_status || '-',
          reference: d?.reference || '-',
        }));

        setClaimHistoryList(tempClaimHistoryList);
        if (activeClaimHistoryListPage === 1) {
          setClaimHistoryListCount(data?.count);
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  };

  const handlePostExport = () => {
    let payload = {
      search: searchClaimHistoryListFilter,
    }

    if (columnFilter) {
      Object.keys(columnFilter).forEach((key) => {
        if (columnFilter[key]) {
          payload[key] = columnFilter[key].value
        } else {
          payload[key] = ''
        }
      })
    }

    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "post",
      url: `/api/gamepass/v1/history/export`,
      data: payload,
      responseType: "blob",
    })
      .then(({ data }) => {
        if (data) {
          const fileBlob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
          const fileUrl = URL.createObjectURL(fileBlob);

          const link = document.createElement('a');
          link.href = fileUrl;
          link.download = `Claim History.xlsx`;

          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
          URL.revokeObjectURL(fileUrl);

          setTimeout(() => {
            setShowModalExportFile({ show: false })
          }, 500)
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  const handleShowModalExport = () => {
    setShowModalExportFile({ show: !showModalExportFile.show })
  }

  return (
    <>
      {
        showModalExportFile?.show && (
          <AppModalConfirmation 
            confirmationType='claimhistory-export'
            showModal={showModalExportFile}
            setShowModal={setShowModalExportFile}
            handleConfirmation={handlePostExport}
            headerTitle={"Please input voucher type and count"}
          />
        )
      }
      <div className='d-grid gap-2 d-md-flex justify-content-md-end mb-3'>
        <CButton style={styleButtonVars2} onClick={handleShowModalExport}>
          Export reports
        </CButton>
      </div>
      <AppCard 
        className='mb-4'
        headerTitle={<h4>{status == 'valid' ? 'Valid' : 'Invalid'} Claim History List</h4>}
        bodyContent={
          <AppTable
            claimHistoryListPage
            tableFilter
            tableColumns={updateColumnList}
            tableContent={claimHistoryList}
            contentPerPage={claimHistoryListPerPage}
            activeContentPage={activeClaimHistoryListPage}
            contentCount={claimHistoryListCount}
            searchContentFilter={searchClaimHistoryListFilter}
            setActiveContentPage={setActiveClaimHistoryListPage}
            setSearchContentFilter={handleSearchItems}
            setContentPerPage={setClaimHistoryListPerPage}
            setColumnContentSorter={setColumnClaimHistoryListSorter}
            isShowDropdownMenu={false}
            isShowColumnFilter={true}
          />
        }
      />
    </>
  )
}

export default ClaimHistoryList